// Module
var code = "<personal-events-dashboard ng-if=$ctrl.canInit component-is-ready=$ctrl.componentIsReady() role=\"{{ $ctrl.role }}\"></personal-events-dashboard>";
// Exports
module.exports = code;